<div class="se-side-nav-class" *ngIf="show">
    <div class="se-side-nav-main-container"
         style="display: flex; overflow: auto">
        <mat-tab-group #matTabGroup
                       mat-stretch-tabs
                       class="se-side-tab-group se-tab-fill-height"
                       [ngClass]="{'se-side-nav-icon-selected__clicked': hideContent}"
                       (selectedTabChange)="onSelectedTabChange($event)">
            <mat-tab *ngFor="let sideComponent of activeSideComponents$ | async; let index = index; let last = last;">
                <ng-template mat-tab-label>
                    <div (click)="onClick(index, sideComponent)" class="icon-container_click" [class.tab-error]="(seSide.tabErrorState$ | async)?.[sideComponent.type]">
                        @if(sideComponent.svgIcon){
                        <mat-icon class="sidenav-icon sidenav-svg-icon estensa-icon"
                                  [matTooltip]="sideComponent.title | translate"
                                  fontSet="estensa-icons">
                            {{sideComponent.svgIcon}}
                        </mat-icon>
                        }@else{
                        <mat-icon class="sidenav-icon" [matTooltip]="sideComponent.title | translate">{{sideComponent.icon}}</mat-icon>
                        }
                    </div>
                </ng-template>

                <div class="se-side-nav-component-container" [ngClass]="!hideContent ? 'side-tab-open' : 'side-tab-close'">
                    <header class="se-side-nav-header">{{sideComponent.title | translate}}</header>
                    <div class="se-side-nav-header__dividing-line"></div>
                    <div [ngSwitch]="sideComponent.type"
                         class="se-side-nav-component-container"
                         style="overflow-y: auto; overflow-x: hidden;">
                        <se-side-patient-history *ngSwitchCase="sideComponentType.patientHistory"
                                                 style="width: 100%">
                        </se-side-patient-history>
                        <div class="se-side-nav-report-history-component-container" *ngSwitchCase="sideComponentType.reportHistory">
                            <se-side-report-history style="width: 100%">
                            </se-side-report-history>
                        </div>
                        <se-side-key-images-container *ngSwitchCase="sideComponentType.keyImagesPreview"
                                                      class="se-side-nav-component-container__key-images"
                                                      [examinationStudies]="(examinationStudies$ | async)||[]">
                        </se-side-key-images-container>
                        <ng-container #reportingContainer *ngSwitchCase="sideComponentType.reporting">
                        </ng-container>
                        <se-side-details *ngSwitchCase="sideComponentType.details"
                                         style="width: 100%; height:100%">
                        </se-side-details>
                    </div>
                </div>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>
